// extracted by mini-css-extract-plugin
module.exports = {"container":"_3rdgHxQw0AGR6JygwFw6RC"};